module.exports = __webpack_public_path__ + "static/media/over.acb9c8e0.jpg";